/* Editorial-only interactions. Never writes a product, variant, bundle or cart. */
if (!customElements.get('mz-tsuru-story')) {
  customElements.define('mz-tsuru-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const dialog = this.querySelector('dialog');
      const zoomImage = dialog?.querySelector('img');
      let origin;

      this.addEventListener('click', event => {
        const link = event.target.closest('[data-tsuru-zoom]');
        if (!link || !dialog?.showModal) return;
        event.preventDefault();
        origin = link;
        zoomImage.src = link.href;
        zoomImage.alt = link.querySelector('img').alt;
        dialog.showModal();
      }, { signal });
      dialog?.querySelector('button')?.addEventListener('click', () => dialog.close(), { signal });
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, { signal });
      dialog?.addEventListener('close', () => origin?.focus({ preventScroll:true }), { signal });

      const video = this.querySelector('video');
      const play = this.querySelector('.mz-tsuru-play');
      if (video && play) {
        let visible = false;
        let manuallyPaused = false;
        let automaticPause = false;
        video.muted = true;
        video.defaultMuted = true;
        play.hidden = false;
        const stop = () => {
          if (!video.paused) {
            automaticPause = true;
            video.pause();
          }
        };
        const syncPlayback = () => {
          if (!visible || document.hidden || reduced.matches) return stop();
          if (!manuallyPaused) video.play().catch(() => { play.hidden = false; });
        };
        play.addEventListener('click', async () => {
          manuallyPaused = false;
          try { await video.play(); } catch { /* Native controls remain available. */ }
        }, { signal });
        video.addEventListener('play', () => {
          automaticPause = false;
          manuallyPaused = false;
          play.hidden = true;
          if (!visible || document.hidden) stop();
        }, { signal });
        video.addEventListener('pause', () => {
          if (!automaticPause && visible && !document.hidden) manuallyPaused = true;
          automaticPause = false;
          play.hidden = false;
        }, { signal });
        document.addEventListener('visibilitychange', syncPlayback, { signal });
        reduced.addEventListener('change', syncPlayback, { signal });
        this.videoObserver = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
          syncPlayback();
        }, { threshold:[0,.15] });
        this.videoObserver.observe(video);
      }

      if (!reduced.matches && 'IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('tsuru-arrive');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold:.08 });
        this.querySelectorAll('[data-tsuru-reveal]').forEach(element => this.revealObserver.observe(element));
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.revealObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.controller = null;
    }
  });
}
